import { startListening } from '@bonanza-social/toolkit/state';
import { fetchCategories } from '@bonanza-social/games/state';
import { statusChanged } from '@bonanza-social/status/state';

startListening({
  actionCreator: statusChanged,
  effect: (_, { dispatch }) => {
    dispatch(fetchCategories('authenticated'));
  },
});
